module.exports = __webpack_public_path__ + "img/29.42b10539.png";